import { darkGray } from '../colors';

export default {
  gutterBottom: {
    marginBottom: 8,
  },
  h3: {
    color: darkGray,
  },
};
